export const HttpsProxyAgent = class {};
export default { HttpsProxyAgent };
